import { Pipe, PipeTransform } from '@angular/core';
/**
 * Si es '1' pone un icon devolución
 */
@Pipe({
  name: 'iconDevolucion'
})

export class iconDevolucionPipe implements PipeTransform {
  transform(value: any): string {
    return value === '1' ? '<i class="text-success fa-solid fa-rotate-left"></i>' : '';
  }
}